// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"1a903b63","317":"95b53bc9","917":"f94dc1c0"}[chunkId] + ".chunk.js";
};